import React, { useState } from 'react'
import { Checkbox, Drawer } from 'antd'
import Select from 'react-select'

import { usePet, useToggle } from '../../modules'

const PatientScheme = ({ toggle, name, visible, scheme: pScheme, onSave }) => {
    const [schemeNo, setSchemeNo] = useState(pScheme?.schemeNo)
    const [scheme, setScheme] = useState(pScheme?.scheme)
    const [claimantName, setClaimantName] = useState(pScheme?.claimantName ?? name ?? '')
    const [utilizedAmount, setUtilizedAmount] = useState(pScheme?.utilizedAmount ?? 0)
    const [balance, setBalance] = useState(pScheme?.balance ?? 0)
    const [schemes, setSchemes] = useState([])
    
    const [main, toggleMain, setMain] = useToggle(pScheme?.main ?? false)

    const [, getSchemes] = usePet('schemes', { active: true, limit: 100 }, { notify: true, callback: async ({ data }) => setSchemes(data?.schemes?.filter(scheme => scheme.name !== 'Cash')) })

    const modify = e => {
        switch (e.target.name) {
            case 'schemeNo':
                setSchemeNo(e.target.value)
                break

            case 'claimantName':
                setClaimantName(e.target.value)
                break

            case 'utilizedAmount':
                setUtilizedAmount(e.target.value)
                break

            case 'balance':
                setBalance(e.target.value)
                break

            case 'main':
                setMain(e.target.value)
                break

            default:
                break
        }
    }

    const close = () => {
        toggle()
    }

    const save = () => {
        onSave({
            schemeNo,
            scheme,
            claimantName,
            utilizedAmount,
            balance,
            main
        })
        close()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={save} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">Patient Medical Scheme</p>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                    Select Scheme
                </label>
                <Select
                    className="mb-3"
                    value={scheme}
                    onChange={setScheme}
                    options={schemes.map(scheme => ({ label: scheme.name, value: scheme._id, ...scheme }))}
                    placeholder="Search Schemes" />
            </div>
            <Checkbox checked={ main } onChange={ toggleMain }>Main Scheme</Checkbox>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Scheme Number
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-schemeNo"
                    type="text"
                    name="schemeNo"
                    value={schemeNo}
                    onChange={modify}
                    placeholder="XXXXXXXX" />
            </div>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Claimant Name
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-claimantName"
                    type="text"
                    name="claimantName"
                    value={claimantName}
                    onChange={modify}
                    placeholder="Evans Kimani" />
            </div>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Utilized Amount
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-utilizedAmount"
                    type="number"
                    name="utilizedAmount"
                    value={utilizedAmount}
                    onChange={modify}
                    placeholder="0" />
            </div>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Balance
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-balance"
                    type="number"
                    name="balance"
                    value={balance}
                    onChange={modify}
                    placeholder="0" />
            </div>
        </Drawer>
    )
}

export default PatientScheme